import { render, staticRenderFns } from "./TOPICDL.vue?vue&type=template&id=1d5c5ef4&scoped=true&"
import script from "./TOPICDL.vue?vue&type=script&lang=js&"
export * from "./TOPICDL.vue?vue&type=script&lang=js&"
import style0 from "./TOPICDL.vue?vue&type=style&index=0&id=1d5c5ef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c5ef4",
  null
  
)

export default component.exports